__turbopack_context__.v({
  "container": "EmptyPostsList-module-scss-module__0hzh9q__container",
  "desc": "EmptyPostsList-module-scss-module__0hzh9q__desc",
  "iconWrapper": "EmptyPostsList-module-scss-module__0hzh9q__iconWrapper",
  "root": "EmptyPostsList-module-scss-module__0hzh9q__root",
  "title": "EmptyPostsList-module-scss-module__0hzh9q__title",
  "trigger": "EmptyPostsList-module-scss-module__0hzh9q__trigger",
});
